import createSelector from 'web-app/util/custom-create-selector';
import DiscountBehaviorIds from 'web-app/behaviors/discount-behavior-ids';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import {type RootState} from 'web-app/react/redux/main-reducer';

export const getPresets = (state: RootState) => state.entities.discounts.presets;

const getDiscountBehaviors = state => new BehaviorsCollection(state.entities.discounts.behaviors);

// Is it bad to have the behaviors collection in the state? I think this might not even work.
export const isSiblingDiscountsEnabled = createSelector(getDiscountBehaviors, behaviors =>
    behaviors.includes(DiscountBehaviorIds.CanUseSiblingDiscounts),
);

export const getPresetsByInstitutionId = createSelector(
    getPresets,
    (state, props: {institutionId: string}) => props.institutionId,
    (presets, institutionId) => {
        return presets
            .filter(preset => preset.institutionId === institutionId)
            .sortBy(preset => preset.ordering)
            .toList();
    },
);
